import { useColors } from "../../../../../hooks/colors/useColors";
import { useUser } from "../../../../../hooks/react-query/useUser";
import { useRedirectAnonymous } from "../../../../../hooks/auth/useRedirectAnonymous";
import { Container } from "../../../../../components/UI/container/Container";
import { IconCheck } from "@tabler/icons";
import { Avatar, Text } from "@mantine/core";
import { MyH1 } from "../../../../../components/UI/my-h1/MyH1";
import { MyButton } from "../../../../../components/UI/my-button/MyButton";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { isMobile } from "react-device-detect";
import { MyHead } from "../../../../../components/pages/MyHead";
import { Fragment } from "react";
import { Footer } from "../../../../../components/pages/homepage/footer/Footer";
// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function BookingPage() {
  const { colors } = useColors();
  const redirect = useRedirectAnonymous();
  const router = useRouter();
  const { user, userIsLoading } = useUser();
  const { t } = useTranslation("common");

  async function goBack() {
    await router.push("/user");
  }

  return (
    <Fragment>
      <MyHead title={t("booking.success")} description={t("booking.success")} />
      {user && !userIsLoading && (
        <Container noHeight>
          <div
            style={{ minHeight: "calc(100vh - 300px)" }}
            className="flex flex-col justify-center items-center gap-4"
          >
            <Avatar
              styles={{ placeholder: { backgroundColor: colors.success } }}
              radius={150}
              size={300}
            >
              <IconCheck size={300} color={colors.white} />
            </Avatar>
            <MyH1 size={isMobile ? "2.5rem" : "3rem"} centerText>
              {t(`booking.success`)}
            </MyH1>
            <Text className="text-2xl text-center">
              {t(`booking.successEmail`)}
            </Text>
            <MyButton
              marginTop
              size="xl"
              fontSize="1.5rem"
              height="3rem"
              onClick={goBack}
              title={t("backProfile")}
              color={colors.secondary}
            />
          </div>
        </Container>
      )}
      <Footer isVisible />
    </Fragment>
  );
}

export default BookingPage;
